<template>
  <div id="header">
    <nav
      class="navbar mobile-navbar no-shadow is-hidden-desktop is-hidden-tablet"
      aria-label="main navigation"
    >
      <div class="container">
        <!-- Brand -->
        <div class="navbar-brand">
          <!-- Mobile menu toggler icon -->
          <div class="brand-start">
            <div
              @click="$router.push({ name: 'Tests' })"
              class="navbar-burger dark-inverted"
              style="
                display: flex;
                align-items: center;
                justify-content: center;
              "
            >
              <i class="lnil lnil-checkmark-circle dark-inverted"></i>
              &nbsp;{{ $t("header.tests") }}
            </div>
          </div>
          <router-link
            :to="{ name: 'Home' }"
            class="navbar-item is-brand"
            style="background-color: transparent !important"
          >
            <img
              class="light-image"
              :src="'/static/img/logo_' + $i18n.locale + '.svg'"
              alt=""
            />
            <img
              class="dark-image"
              :src="'/static/img/logo_' + $i18n.locale + '.svg'"
              alt=""
            />
          </router-link>

          <div
            v-if="$store.state.user != null"
            class="brand-end dark-inverted flex-column"
            style="text-align: right; font-size: 12px"
          >
            <span>{{ $store.state.user.firstname }}</span>
            <a href="javascript:;" @click="logout">{{ $t("header.logout") }}</a>
          </div>
        </div>
      </div>
    </nav>
    <!--Mobile sidebar-->

    <!--Webapp navbar regular-->
    <div class="webapp-navbar" v-if="1 == 0">
      <div class="webapp-navbar-inner">
        <div class="left">
          <a href="/" class="brand">
            <img
              class="light-image"
              :src="'/static/img/logo_' + $i18n.locale + '.svg'"
              alt=""
            />
            <img
              class="dark-image"
              :src="'/static/img/logo_' + $i18n.locale + '_light.svg'"
              alt=""
            />
          </a>
        </div>
        <div class="center">
          <div id="webapp-navbar-menu" class="centered-links">
            <router-link
              style="position: relative"
              :to="{ name: 'Home' }"
              class="centered-link centered-link-toggle"
            >
              <i class="lnir lnir-home"></i>
              <span>{{ $t("header.home") }}</span>
            </router-link>
            <router-link
              style="position: relative"
              :to="{ name: 'Courses' }"
              class="centered-link centered-link-toggle"
            >
              <i class="lnir lnir-book"></i>
              <span>{{ $t("header.education") }}</span>
            </router-link>
            <router-link
              :to="{
                name:
                  $store.state.user.level == 'İlkokul'
                    ? 'ExercisesChild'
                    : 'Exercises',
              }"
              class="centered-link centered-link-toggle"
            >
              <i class="lnir lnir-brain-alt"></i>
              <span>{{ $t("header.exercises") }}</span>
            </router-link>

            <router-link
              style="position: relative"
              :to="{ name: 'Tests' }"
              class="centered-link centered-link-toggle"
            >
              <span
                style="
                  width: 20px;
                  height: 20px;
                  border-radius: 50%;
                  color: white;
                  background: red;
                  position: absolute;
                  right: 4px;
                  top: 4px;
                  font-size: 12px !important;
                  font-weight: bold;
                "
                v-if="
                  $store.state.tests.filter(
                    (k) => k.question_count != k.answer_count
                  ).length > 0
                "
              >
                {{
                  $store.state.tests.filter(
                    (k) => k.question_count != k.answer_count
                  ).length
                }}
              </span>
              <i class="lnir lnir-checkmark"></i>
              <span>{{ $t("header.tests") }}</span>
            </router-link>
          </div>
        </div>
        <div class="right">
          <div class="toolbar ml-auto">
            <div class="toolbar-link">
              <label class="dark-mode ml-auto">
                <input
                  type="checkbox"
                  v-model="$store.state.darkmode"
                  :value="1"
                />
                <span></span>
              </label>
            </div>
          </div>
          <div
            class="
              profile-dropdown
              dropdown-trigger
              is-spaced is-right
              dark-inverted
            "
            v-if="$store.state.user != null"
          >
            {{ $store.state.user.firstname }}<br />
            <a href="javascript:;" @click="logout">{{ $t("header.logout") }}</a>
            <span class="status-indicator"></span>
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="$route.name == 'ExerciseDetail'"
      style="
        width: 100%;
        font-size: 24px;
        background-color: #1c449c;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 4px 15px;
        height: 53px;
      "
      class="dark-inverted exercise-detail-header"
    >
      <span
        style="
          color: white;
          font-size: 17px;
          margin-left: 10px;
          display: flex;
          flex: 1;
          text-align: center;
          align-items: center;
          justify-content: center;
          padding-left: 150px;
        "
        >{{
          $t(
            "cats." +
              $store.state.modules.find((k) => k.slug == $route.params.type)
                .category
          )
        }}
        >
        {{
          $t(
            "modules." +
              $store.state.modules.find((k) => k.slug == $route.params.type)
                .title
          )
        }}</span
      >
      <span style="display: flex; align-items: center">
        <a
          href="javascript:;"
          style="color: white; margin-left: 30px"
          @click="fullScreen"
        >
          <i class="fas fa-expand"></i>
        </a>

        <a
          href="javascript:;"
          style="color: white; margin-left: 20px; margin-right: 10px"
          @click="
            $store.state.selectedTick2 == 'sessiz'
              ? ($store.state.selectedTick2 = 'Ses1')
              : ($store.state.selectedTick2 = 'sessiz')
          "
        >
          <i
            :class="
              'fas fa-' +
              ($store.state.selectedTick2 == 'sessiz'
                ? 'volume-mute'
                : 'volume-up')
            "
          ></i>
        </a>

        <label
          class="dark-mode ml-auto"
          style="
            transform: scale(0.6);
            margin-left: 10px;
            display: inline-block;
          "
        >
          <input type="checkbox" v-model="$store.state.darkmode" />
          <span></span>
        </label>

        <a
          @click="$store.state.scale -= 0.05"
          href="javascript:;"
          style="color: white; margin-left: 10px; margin-right: 10px"
        >
          <i class="fas fa-search-minus"></i>
        </a>

        <a
          @click="$store.state.scale += 0.05"
          href="javascript:;"
          style="color: white; margin-left: 10px; margin-right: 10px"
        >
          <i class="fas fa-search-plus"></i>
        </a>

        <a
          @click="back"
          href="javascript:;"
          style="color: white; margin-left: 30px; margin-right: 10px"
        >
          <i class="fas fa-times"></i>
        </a>
      </span>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import $ from "jquery";
import { io } from "socket.io-client";
export default {
  name: "Header",
  methods: {
    logout() {
      localStorage.removeItem("token");
      window.location.href = "/";
    },
    back() {
      this.$router.back();
    },
    fullScreen() {
      var isInFullScreen =
        (document.fullscreenElement && document.fullscreenElement !== null) ||
        (document.webkitFullscreenElement &&
          document.webkitFullscreenElement !== null) ||
        (document.mozFullScreenElement &&
          document.mozFullScreenElement !== null) ||
        (document.msFullscreenElement && document.msFullscreenElement !== null);

      var docElm = document.documentElement;
      if (!isInFullScreen) {
        if (docElm.requestFullscreen) {
          docElm.requestFullscreen();
        } else if (docElm.mozRequestFullScreen) {
          docElm.mozRequestFullScreen();
        } else if (docElm.webkitRequestFullScreen) {
          docElm.webkitRequestFullScreen();
        } else if (docElm.msRequestFullscreen) {
          docElm.msRequestFullscreen();
        }
      } else {
        if (document.exitFullscreen) {
          document.exitFullscreen();
        } else if (document.webkitExitFullscreen) {
          document.webkitExitFullscreen();
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        } else if (document.msExitFullscreen) {
          document.msExitFullscreen();
        }
      }
    },
  },
  data() {
    return {
      x: this.$store.state.darkmode,
    };
  },
  watch: {
    "$store.state.darkmode": function (newww) {
      if (newww === false) {
        localStorage.removeItem("darkmode", 1);
        $("body").removeClass("is-dark");
        $("html").removeClass("is-dark");
      } else {
        localStorage.setItem("darkmode", 1);
        $("body").addClass("is-dark");
        $("html").addClass("is-dark");
      }
    },
    "$store.state.selectedTick2": function () {
      localStorage.setItem("tick2", this.$store.state.selectedTick2);
    },
  },
  created() {

  },
};
</script>



// WEBPACK FOOTER //
// src/components/Header.vue